<template>
  <div class="table-grid">
    <ion-grid :scroll-x="true" class="option-row ml-10 mr-10" nowrap>
      <div :style="styleGridTemplateColumns(orderedHeaders.length)" class="grid-header">
        <div class="grid-text" v-for="(header, headerIndex) in orderedHeaders" :key="headerIndex"> {{ header }}</div>
      </div>
      <div :style="styleGridTemplateColumns(row.length)" class="grid-items" v-for="(row, index) in orderedRows" :key="index">
        <div class="grid-text" v-for="(item, itemIndex) in row" :key="itemIndex"> {{ getVal(item, row, itemIndex) }}</div>
      </div>
    </ion-grid>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: "PerPeriodScore",
  props: ['headers', 'rows'],
  data() {
    return {
      nationalId : +process.env.VUE_APP_NATIONAL_ID,
    }
  },
  computed: {
    orderedHeaders() {
      return this.headers;
    },
    orderedRows() {
      return this.rows;
    },
    orderedHeadersNum() {
      return this.headers.length;
    },
    orderedRowsNum() {
      return this.rows.length;
    },
  },
  methods: {
    styleGridTemplateColumns(numColumns) {
      const style = {gridTemplateColumns: `repeat(${numColumns}, 1.5rem)`};
      return style;
    },
    getVal(item, row, itemIndex) {
      if (this.nationalId === 8) {
        // Goal + Penalty Goal
        return itemIndex === 2 ? row[itemIndex] + row[itemIndex + 1] : item;
      }

      return item;
    }
  }
};
</script>

<style scoped>
.table-grid {
  /* background: #1d1f22;
  padding: 1rem 1.5rem; */
  /* border-radius: 14px; */
  /* width: 100%; */
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  line-height: 1rem;
  display: flex;
  justify-items: center;
  /* text-align: center; */
  /* color: #fff; */
  /* grid-template-columns: ; */
}

.grid-header {
  display: grid;
  /* gap: 0.1rem; */
  /* grid-template-columns: 4rem 8rem 4rem repeat(auto-fill, 4rem); */
  /* padding: 0.5rem 1.5rem; */
  margin-bottom: 0.8rem;
  color: #a9a9a9;
  font-size: 0.8rem;
  font-weight: bold;
  text-overflow: clip;
  white-space: nowrap;
  grid-template-columns: repeat(v-bind(orderedHeadersNum), 1.5rem);
}

.grid-items {
  display: grid;
  /* gap: 0.1rem; */
  /* grid-template-columns: 4rem 8rem 4rem repeat(auto-fill, 4rem); */
  /* background: #1d1f22; */
  /* padding: 1rem 1.5rem; */
  /* width: 100%; */
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  line-height: 1rem;
  /* color: #fff; */
  text-overflow: clip;
  white-space: nowrap;
  margin-left: auto;
  margin-right: auto;
  grid-template-columns: repeat(v-bind(orderedHeadersNum), 1.5rem);
}

span {
  display: flex;
  justify-items: center;
  text-align: justify;
  width: 100%;
}
.grid-text {
  display: flex;
  justify-content: center;
}
.option-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  border-radius: 1rem;
  /* background: #1e1f22 !important; */
}

@media only screen and (max-width: 600px) {
  .grid-header {
    font-size: 0.7rem;
    margin-bottom: 0.4rem;
    grid-template-columns: repeat(v-bind(orderedHeadersNum), 1.1rem);
  }
  .grid-items {
    font-size: 0.6rem;
    grid-template-columns: repeat(v-bind(orderedHeadersNum), 1.1rem);
  }

  .grid-text {
    padding: 0;
  }
}

</style>
